export default "__VITE_ASSET__DSzb9c1x__"